// Function to generate dynamic answers based on form type
export function generateDynamicAnswer(type, options) {
  switch (type) {
    case "info":
      return generateMultipleChoiceGridAnswerORInfoAnswer(options);
    case "text":
      return generateStringAnswer(options);
    case "shortResponse":
      return generateStringAnswer(options);
    case "yesNo":
      return generateYesNoAnswer(options);
    case "multipleChoiceButton":
      return generateMultipleChoiceAnswer(options);
    case "time":
      return generateStringAnswer(options);
    case "scale":
      return generateStringAnswer(options);
    case "number":
      return generateStringAnswer(options);
    case "calender":
      return generateStringAnswer(options);
    case "multipleChoiceGrid":
      return generateMultipleChoiceGridAnswerORInfoAnswer(options);
    case "multiChoice":
      return generateMultipleChoiceAnswer(options);
    case "longResponse":
      return generateStringAnswer(options);
    case "richText":
      return generateRichTextAnswer(options);
    case "waiverClient":
      return generateWaiverClientAnswer(options);
    default:
      return null;
  }
}


// Function to generate dynamic answer for 'text shortAnswer time scale number calander longResponse' type 7 types here
function generateStringAnswer(options) {
  return "";
}

// Function to generate dynamic answer for 'yesNo' type
function generateYesNoAnswer(options) {
  return false;
}

// Function to generate dynamic answer for 'multipleChoiceButton  multiChoice' type 2 types here
function generateMultipleChoiceAnswer(options) {
  const answer = {};
  options.forEach((option) => {
    answer[option] = false;
  });
  return answer;
}

// Function to generate dynamic answer for 'multipleChoiceGrid generateInfoAnswer' type  2 types here
function generateMultipleChoiceGridAnswerORInfoAnswer(options) {
  const answer = {};
  options.forEach((option) => {
    answer[option] = "";
  });
  return answer;
}


// Function to generate dynamic answer for 'richText' type
function generateRichTextAnswer(options) {
  return { title: "" };
}

// Function to generate dynamic answer for 'waiverClient' type
function generateWaiverClientAnswer(options) {
  return { name: "", acknowledged: false };
}
